import HttpResponse from "../../../../../utils/http/http.response";

export enum TaxiCorporationUnbilledOrdersListResponseDataItemMissingBillings {
  CARGO_TAXI = "CARGO_TAXI",
}

export type TaxiCorporationUnbilledOrdersListResponseDataItemClient = {
  name: string;
};

export type TaxiCorporationUnbilledOrdersListResponseDataItem = {
  id: string;
  startTime: Date;
  humanId: number;
  isCancelled: boolean;
  rideAddresses: (string | string[])[];
  passengers: string[];
  dispatch: string;
  client: TaxiCorporationUnbilledOrdersListResponseDataItemClient;
  taxiCorporations: string[];
  drivers: string[];
  externalId: string | null;
  missingTaxiBillings: TaxiCorporationUnbilledOrdersListResponseDataItemMissingBillings[];
};

export type TaxiCorporationUnbilledOrdersListResponseData = {
  data: TaxiCorporationUnbilledOrdersListResponseDataItem[];
  totalCount: number;
};

type TaxiCorporationUnbilledOrdersListResponse =
  HttpResponse<TaxiCorporationUnbilledOrdersListResponseData>;

export default TaxiCorporationUnbilledOrdersListResponse;
